<template>
  <div>
    <breadcrumb-component
        :mainTitle="'IAM'"
        :moduleTitle="'Vlan Cloud'"
        :subTitle="'IAM'"
    />
    <div class="row">
      <div class="col-md-12">
        <div class="card card_full_window vc_account_page ">
          <div class="card-body">
            <div class="common_content_wrap no_left_content">
              <h5 class="common_subtitle pb_15 border-lightgray-bottom mb_0">User Manage Area</h5>
              <div v-if="hasPermission" class="common_tab_list">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <template v-for="tab in tabs" :key="`tab_${tab.id}`">
                  <li
                      v-if="!tab.permission || can(tab.permission)"
                      role="presentation"
                      class="nav-item"
                      :class="{active: selectedTab === tab.id}"
                      @click="selectTab(tab.id)"
                  >
                    <button
                        class="nav-link"
                        :class="{active: selectedTab === tab.id}"
                        id="Account-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Account-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="Account-tab-pane"
                        :aria-selected="{active: selectedTab === tab.id}"
                    >
                      {{ tab.name }}
                    </button>
                  </li>
                  </template>
                </ul>
              </div>
              <div v-else>
                <p>You do not have permission to view this content.</p>
              </div>
              <div v-if="hasPermission" class="common_tab_content">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="Account-tab-pane" role="tabpanel" aria-labelledby="Account-tab" tabindex="0">
                    <div class="my_account_content">
                      <component
                          :is="selectedComponent"
                          :selectedTab="selectedTab"
                      >
                      </component>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {shallowRef} from "vue";
import BreadcrumbComponent from "@/components/shared/BreadcrumbComponent.vue";
import User from "@/views/iam/User.vue";
import Policy from "@/views/iam/Policy.vue";
import PolicyGroup from "@/views/iam/PolicyGroup.vue";
import AuditLog from "@/views/iam/AuditLog.vue";
import {useAbility} from "@casl/vue";

export default{
  name: "IamTabIndex",
  components: {BreadcrumbComponent},
  data() {
    return {
      tabs: [
        { id: 1, name: 'User', component: shallowRef(User), permission: 'user_list' },
        { id: 2, name: 'Policy', component: shallowRef(Policy), permission: 'policy_list' },
        { id: 3, name: 'Policy Group', component: shallowRef(PolicyGroup), permission: 'policy_group_list' },
        { id: 4, name: 'Audit Log', component: shallowRef(AuditLog), permission: 'audit_log_list' },
      ],
      selectedTab: 1,
    }
  },
  computed: {
    selectedComponent() {
      return this.tabs.find(el => el.id === this.selectedTab).component;
    },
    hasPermission() {
      return this.tabs.some(tab => !tab.permission || this.can(tab.permission));
    }
  },
  methods: {
    selectTab(selectedTab) {
      this.$router.replace({ path: this.$route.path });
      this.selectedTab = selectedTab;
    },
  },
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
}
</script>
<style scoped>

</style>